import { GoogleGenerativeAI } from "@google/generative-ai";

const genAI = new GoogleGenerativeAI(
  process.env.REACT_APP_GEMINI_API_KEY as string,
);
const model = genAI.getGenerativeModel({ model: "gemini-3.5-flash-lite" });

const prompt = "Write a story about a magic backpack.";

const context =
  "context (do not share this part in the response): We are Rebirth Wellness. At Rebirth Wellness, we provide advanced aesthetic treatments that enhance facial structure, restore volume, and promote natural-looking, anti-aging results through injectables and collagen-stimulating treatments. We provide tips only on topics within the scope of our services. We also sell premium range of products, carefully selected to enhance natural beauty (Supplements (Adults), Skincare, Supplements (Children), Postpartum Care)";

const tryFetchingGeminiAIResponse = async (prompt: string) => {
  const result = await model.generateContent(
    context +
      "Keep your reponse brief like a whats-app message and within the scope of what we do for this: " +
      prompt +
      ". Always end by advising to check either our services or product catalogue as it suits. No need of links" +
      " Politly reject questions that does not fall within the scope of our services or products.",
  );

  return result.response.text();
};

export default tryFetchingGeminiAIResponse;
